import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const TravelRequestViewChunk = lazy(() =>
  import('../feature-sets/TravelRequestView').then(({ TravelRequestView }) => ({
    default: TravelRequestView,
  }))
)

export const TravelRequestPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.travelRequestPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.travelRequestPageTitle),
        },
      ]}
    >
      <TravelRequestViewChunk />
    </Page>
  )
}
